<style lang="scss" scoped>
.popup {
    overflow: scroll;
    -ms-overflow-style: none;
}

.add-gift {
    p {
        font-size: 1.25rem;
        font-weight: 300;
        line-height: 1.875rem;
    }

    .ar {
        position: relative;
    }

    img {
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;

        border-radius: 4px;
        width: 100%;
        height: 100%;
        object-fit: cover;
        font-family: "object-fit: cover;";
        -webkit-user-drag: none;
    }

    .title {
        font-size: 1rem;
        font-weight: 500;
        margin-bottom: 0;
        line-height: 1.25rem;
    }
}

.gift {
    cursor: pointer;
}
</style>

<template>
    <div class="popup px-16 py-24 p-md-24 p-lg-56" ref="fixBottom">
        <div class="close" @click="$emit('close')"></div>
        <div class="add-gift">
            <h2 class="mb-32">{{ translations.add_gift_popup.title }}</h2>

            <p class="mb-24" v-html="translations.add_gift_popup.description"></p>

            <div class="row mb-n32">
                <div class="col-6" v-for="gift in itemsWithoutAlreadySelectedGifts" :key="gift.id">
                    <div class="gift mb-32" @click="addGift(gift)">
                        <div class="ar mb-8" :style="{ 'padding-top' : `${ (arHeight / arWidth) * 100 }%` }">
                            <img :src="gift.acf.image.sizes.medium_large" :alt="gift.post_name">
                        </div>
                        <p class="title" v-html="gift.post_title"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import core from "../day-configurator-core";
import safariFixedBottom from "../../mixins/safari-fixed-bottom";
import { bus } from '@/app';

export default {
    mixins: [core, safariFixedBottom],

    data: () => ({
        page: null,
        ratio: '284:200'
    }),

    props: {
        items: {
            required: true,
        },
    },

    methods: {
        addGift(gift) {
            const gift_object = {
                type: 'listed',
                data: {
                    external_id: gift.id,
                    external_type: gift.post_type === 'tribe-box' ? 'tribeBox' : 'gift',
                }
            }
            this.$store.dispatch('dayConfigurator/addExternalActivity', gift).then(() => {
                this.$store.dispatch('dayConfigurator/addGift', gift_object).then(() => {
                    this.$store.dispatch('dayConfigurator/update', { schedule: this.schedule, set: false });
                    this.$emit('close');
                });
            });
        }
    },

    computed: {
        arWidth() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[0]
        },

        arHeight() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[1]
        },

        itemsWithoutAlreadySelectedGifts() {
            const gifts = this.items.gift;
            const tribeBoxes = this.items.gift;

            if (gifts != null) {
                const selectedGifts = this.schedule.gifts;

                return gifts.filter((s) => {
                    return selectedGifts.filter((g) => {
                        return g.data.external_id == s.id;
                    }).length === 0;
                });
            }

            return [];

        }
    }
}
</script>